import React, { useEffect, useState } from 'react';
import { Modal, Button, Input, Form } from 'antd';
import { toast } from 'react-toastify';
import { editTypeOffer } from '../../../../../services/offers/typeOffersApi'; // Ensure this API function is defined

const EditTypeOffer = ({ isOpen, onClose, onSubmit, typeOffer }) => {
    const [nom, setNom] = useState(''); // State for type offer name
    const [errors, setErrors] = useState({}); // State for validation errors

    const clearState = () => {
        setNom(''); // Reset input field
        setErrors({}); // Reset errors
    };

    useEffect(() => {
        if (isOpen && typeOffer) {
            setNom(typeOffer.nom); // Set the name from the typeOffer prop
        } else {
            clearState(); // Clear state when modal is closed
        }
    }, [isOpen, typeOffer]);

    const handleSubmit = () => {
        const data = { nom }; // Prepare data for submission

        editTypeOffer(typeOffer.id, data) // Call the API to edit the type offer
            .then((response) => {
                toast.success('Type offer updated successfully!'); // Notify success
                onSubmit(); // Call the onSubmit prop to refresh data
                onClose(); // Close the modal
                clearState(); // Clear the state
            })
            .catch((error) => {
                if (error.response && error.response.data && error.response.data.errors) {
                    setErrors(error.response.data.errors); // Set errors from API response
                }
            });
    };

    return (
        <Modal
            title="Edit Type Offer"
            visible={isOpen}
            onCancel={onClose}
            footer={[
                <Button key="cancel" onClick={onClose}>
                    Fermer
                </Button>,
                <Button key="submit" type="primary" onClick={handleSubmit}>
                    Mettre à jour
                </Button>,
            ]}
        >
            <Form layout="vertical">
                <Form.Item
                    label="Nom du type d'offre"
                    validateStatus={errors.nom ? 'error' : ''}
                    help={errors.nom ? errors.nom[0] : ''}
                >
                    <Input
                        value={nom}
                        onChange={(e) => setNom(e.target.value)}
                        placeholder="Nom du type d'offre"
                        required
                    />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default EditTypeOffer; 